import { PropsWithChildren } from 'react';
import { SegmentTypeEnum } from '@/api/apis/route';

const getOutlinedColor = (segmentType: SegmentTypeEnum) => {
  switch (segmentType) {
    case SegmentTypeEnum.hub:
    case SegmentTypeEnum.dhToHub:
      return '#70C8D2';
    case SegmentTypeEnum.txcenter:
      return '#EDB5B5';
    case SegmentTypeEnum.hospital:
      return '#F6D1AC';
    default:
      return '#70C8D2';
  }
};

const getFilledColor = (segmentType: SegmentTypeEnum, type: 'start' | 'end') => {
  switch (segmentType) {
    case SegmentTypeEnum.hub:
    case SegmentTypeEnum.dhToHub:
      return type === 'start' ? '#B8E1E5' : '#0F8B99';
    case SegmentTypeEnum.txcenter:
      return type === 'start' ? '#EDB5B5' : '#9B1C1C';
    case SegmentTypeEnum.hospital:
      return type === 'start' ? '#F6D1AC' : '#E78521';
    default:
      return '#0F8B99';
  }
};

type LocationMarkerProps = {
  variant: 'outlined' | 'filled';
  type: 'start' | 'end';
  size?: 'sm' | 'md';
  segmentType: SegmentTypeEnum;
  useMonoFont?: boolean;
};

export const LocationMarker = ({
  variant,
  type,
  segmentType,
  children,
  size = 'sm',
  useMonoFont = false,
}: PropsWithChildren<LocationMarkerProps>) => {
  const textColorClass = type === 'end' && variant === 'filled' ? 'text-white' : 'text-base-10';
  const borderColor = getOutlinedColor(segmentType);
  const bgColor = getFilledColor(segmentType, type);
  const textSize = size === 'sm' ? 'text-s-m' : 'text-l-m';

  return (
    <span
      className={`${useMonoFont ? 'font-mono' : ''} flex justify-center items-center px-1 ${textSize} ${textColorClass} border-2 rounded`}
      style={{
        borderColor: variant === 'outlined' ? borderColor : bgColor,
        backgroundColor: variant === 'outlined' ? 'transparent' : bgColor,
      }}
    >
      {children}
    </span>
  );
};
